var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React, { forwardRef } from 'react';
import { Button as ArcoButton } from '@arco-design/web-react';
import { useConfigContext } from '@m4b-design/config-provider';
import cx from 'classnames';
import './style/group.less';
var GroupRender = function GroupRender(props, ref) {
  var _a;
  var _b = useConfigContext(),
    globalPrefixCls = _b.prefixCls,
    rtl = _b.rtl;
  var prefixCls = "".concat(globalPrefixCls, "-button-group");
  return /*#__PURE__*/React.createElement(ArcoButton.Group, __assign({
    "data-tid": "m4b_button_group"
  }, props, {
    className: cx(prefixCls, props.className, (_a = {}, _a["".concat(prefixCls, "-rtl")] = rtl, _a)),
    ref: ref
  }));
};
var Group = /*#__PURE__*/forwardRef(GroupRender);
Group.displayName = 'Button.Group';
export default Group;